// extracted by mini-css-extract-plugin
module.exports = {"modalItem":"styles_modalItem__YKbSY"};